var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"ProductsBlock row py-4"},_vm._l((_vm.products),function(product){return _c('div',{key:product.id,staticClass:"col-24 col-lg-8 col-xl-6 mb-3"},[_c('ProductBox',{attrs:{"product":product}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }